const AnimatedBackground = () => {
  return (
    <div
      className="fixed inset-0 bg-custom-gradient"
    />
  );
};

export default AnimatedBackground;
